var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"font-app-bold",class:{'is-selected': _vm.isSelected},attrs:{"aria-selected":(_vm.isSelected ? 'true' : 'false')},on:{"click":_vm.clickEvent}},[_vm._v("\n    "+_vm._s(_vm.__(_vm.label))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }